import React from 'react';
import Lottie from 'lottie-react';
import LockAnim from '../assets/lock.json';

export const LockIcon = ({ size = 20 }: { size?: number }) => (
    <Lottie animationData={LockAnim} loop={true} style={{ width: size, height: size }} />
);
